import { apiFetch } from '@crowdex/host-kit/renderer/http';
import type { CloudRuntime } from '@/lib/cloud-runtime/cloud-runtime';

/** A cloud sandbox port forwarded to this machine by the local Crowdex server. */
export type PortForward = { conversation: string; remotePort: number; localPort: number };

export function listPortForwards(): Promise<PortForward[]> {
  return apiFetch<PortForward[]>('/api/local/port-forwards');
}

/** Forwards a port of the conversation's sandbox to this machine (again: renews its target). */
export function startPortForward(
  runtime: CloudRuntime,
  conversation: string,
  remotePort: number,
): Promise<PortForward> {
  return apiFetch<PortForward>('/api/local/port-forwards', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      conversation,
      workspaceUrl: runtime.url,
      token: runtime.token,
      remotePort,
    }),
  });
}

export function stopPortForward(conversation: string, remotePort: number): Promise<unknown> {
  const query = new URLSearchParams({ conversation, remotePort: String(remotePort) });
  return apiFetch(`/api/local/port-forwards?${query}`, { method: 'DELETE' });
}

/** Opens a forwarded port in the user's own browser (the system's, from Desktop). */
export function openForwardedPort(localPort: number): void {
  window.open(`http://localhost:${localPort}/`, '_blank', 'noopener,noreferrer');
}
